
<ng-container style="margin-top:50px;" *ngIf="isreferralScreen">
  <div class="wrapper">
    <div class="container flex-grow-1 mt-5" style="padding-left:5px;padding-right:5px;">
      <div class="fw-bold">
        <h5 class="title fw-bold text-center mb-2 mt-2 ">Referral Physician Selection<span class="ml-1 text-dark"><i class="fas fa-info-circle " (click)="showReferralInfoPopup()"></i></span></h5>
      </div>
      <div class="card border mb-4 mt-4" style="padding:9px;" *ngIf="referralStatus !== 'noSuggestedProvider'">
        <div (click)="toggleSpecialistList()" class="d-flex justify-content-between align-items-center fw-bold" style="cursor: pointer;">
          <span style="color:#455A64;font-size:19px">Select the provider you have scheduled your appointment with:</span>
          <!-- Dropdown Icon -->
          <i class="fa" [ngClass]="showSpecialists ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>
        <div class="specialist-list mt-3" *ngIf="showSpecialists">

          <div class="row">
            <div class="col-lg-6" *ngFor="let ref of referrals">
              <div class="card mb-3" [ngClass]="{'selected-card': selectedProvider === ref}" (click)="selectProvider(ref,'suggested')">
                <div class="card-body p-0">
                  <div class="align-items-center d-flex justify-content-between mb-2">
                    <h6 class="font-weight-bold mb-0"  style="font-size:19px !important">{{ref.firsT_NAME | titlecase }} {{ref.lasT_NAME | titlecase }}</h6>
                    <div class="">
                      <i *ngIf="selectedProvider === ref" class="fas fa-check-circle check-icon"></i>
                    </div>
                  </div>
                  <div class="specialist-list" style="font-size:19px !important">
                    <div class="mb-2">
                      <span>Speciality:</span>
                      <span class="text-muted ml-1 font-weight-bold">{{ref.speciality | titlecase }}</span>
                    </div>
                    <div *ngIf="ref.phonE_NO">
                      <span>Phone:</span>
                      <span class="text-muted ml-1 font-weight-bold">{{ref.phonE_NO|| 'N/A'}}</span>
                    </div>
                    <div *ngIf="ref.faX_NO" class="mt-2">
                      <span>Fax:</span>
                      <span class="text-muted ml-1 font-weight-bold">{{ref.faX_NO || 'N/A'}}</span>
                    </div>
                    <!--<div *ngIf="ref.email">
                      <span>Email:</span>
                      <span class="text-muted ml-1 font-weight-bold">{{ref.email|| 'N/A'}}</span>
                    </div>-->

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- by search-->
      <div class="row"  [ngClass]="{ 'mb-4 mt-4': referralStatus == 'noSuggestedProvider' }">
        <div class="from group col-md-12 ">

          <div class="border-bottom">
            <div class="form-label padding-left fw-bold" style="font-size:19px">
             <span *ngIf="referralStatus !== 'noSuggestedProvider'"> I would like to choose a different provider</span>
             <span *ngIf="referralStatus == 'noSuggestedProvider'"> Please search for and select the provider you would like to be referred to.</span>
            </div>

            <div class="input-group mt-2">

              <input placeholder="Search By Name or NPI" autocomplete="off"
                     class="form-control text-left border-0" type="text" id="ref" [(ngModel)]="searchStr" (input)="searchProvider()"  style="font-size:19px !important">

              <span class="input-group-text">
                <i class="fa fa-search"></i>
              </span>

              <span class="input-group-text">
                <i class="fa fa-sliders-h" (click)="openAdvancedSearch()"></i>
              </span>
            </div>
          </div>
          <div>
            <span class="err" *ngIf="nameNPIMissing">
              Name or NPI is missing.
            </span>
          </div>


        </div>
        <div class="col-md-12 mt-3" *ngIf="isAdvancedSearch">
          <div class="row">
            <div class="col-md-3 col-lg-3 pb-2">
              <div class=" mb-2 border-bottom">
                <label class="form-label padding-left fw-bold" style="font-size:19px !important">Speciality</label>
                <div class="input-group">
                  <div class="dropdown input-icon search" ngbDropdown
                       #specialityDropPopUp="ngbDropdown" style="flex: 2;">
                    <input placeholder="Search Speciality" autocomplete="off"
                           class="form-control text-left text-capitalize border-0" type="text"
                           id="dropdownMenu2" aria-haspopup="true" aria-expanded="false"
                           [(ngModel)]="speciality"
                           (input)="PatientSpecialitySearch($event)" ngbDropdownAnchor
                           (focus)="specialityDropPopUp.open()" style="font-size:19px !important">


                    <div ngbDropdownMenu class="custom-menu" aria-labelledby="dropdownMenu2">


                      <button ngbDropdownItem *ngIf="filteredspeciality?.length === 0">
                        No record Found
                      </button>
                      <button ngbDropdownItem *ngFor="let items of filteredspeciality"
                              (click)="SetSpecialitySearch(items.description)">
                        <span class="text-capitalize">
                          {{items.description | titlecase }}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>

              </div>
          </div>


            <div class="col-md-3 col-lg-3 pb-2 ">
              <div class="form-group mb-2 border-bottom">
                <label class="form-label padding-left fw-bold" style="font-size:19px !important">ZIP</label>
                <input type="text" placeholder="{{'updateinfo.zip_placeholder'|translate}}" maxlength="10"
                       autocomplete="off" class="form-control border-0" [(ngModel)]="ptZip" (input)="onFocusOutZIPFinancial($event.target,0)"
                       style="font-size:19px !important">
              </div>

              <div>
                <span class="err" id="f-zip-err" *ngIf="isZipCodeNotValidFinancialInfo">
                  {{'updateinfo.enter_valid_zip_code'|translate}}
                </span>
              </div>
            </div>
            <div class="col-md-3 col-lg-3 pb-2">
              <div class="form-group form-select mb-2 border-bottom">
                <label class="form-label padding-left fw-bold" style="font-size:19px !important">City</label>
                <select class="form-control text-capitalize border-0" [(ngModel)]="ptCity"
                        [ngModelOptions]="{standalone: true}" style="font-size:19px !important">
                  <option *ngFor="let city of _cityandstate" [value]="city.cityName">
                    {{city.cityName | lowercase}}
                  </option>
                </select>

              </div>
            </div>
            <div class="col-md-3 col-lg-3 pb-2">
              <div class="form-group mb-2 border-bottom">
                <label class="form-label padding-left fw-bold" style="font-size:19px !important">State</label>
                <input type="text" placeholder="State" [(ngModel)]="ptState" class="form-control border-0" style="font-size:19px !important">
              </div>

            </div>

          </div>
          <div class="text-center" style="font-size:18px">
            <button class="btn btn-primary btncare" (click)="searchReferralProvider()">Search Provider</button>
          </div>
        </div>
        <div class="col-md-12">
          <div *ngIf="noRecs && !searchingSpecialist && results.length == 0" class="text-center mt-5">
            <span>{{'careteam.no_records_found'|translate}}</span>
          </div>
          <div *ngIf="searchingSpecialist" class="text-center mt-5">
            <span>{{'careteam.loading'|translate}}</span>
          </div>
          <div class="specialist-list mt-3">
            <div class="row">
              <div class="col-lg-6" *ngFor="let c of results">
                <div class="card mb-3" [ngClass]="{'selected-card': selectedProvider === c}" (click)="selectProvider(c,'search')">
                  <div class="card-body p-0">
                    <div class="align-items-center d-flex justify-content-between mb-2">
                      <h6 class="font-weight-bold mb-0"  style="font-size:19px !important">{{c.basic?.first_name | titlecase}} {{c.basic?.last_name | titlecase}}</h6>
                      <div class="">
                        <i *ngIf="selectedProvider === c" class="fas fa-check-circle check-icon"></i>
                      </div>
                    </div>
                    <div class="specialist-list"  style="font-size:19px !important">
                      <div class="mb-2">
                        <span>Speciality:</span>
                        <span class="text-muted ml-1 font-weight-bold">{{c.taxonomies[0]?.desc | titlecase}}</span>
                      </div>
                      <div *ngIf="c.addresses[0]?.telephone_number">
                        <span>Phone:</span>
                        <span class="text-muted ml-1 font-weight-bold">{{c.addresses[0]?.telephone_number}}</span>
                      </div>
                      <div  *ngIf="c.addresses[0]?.fax_number" class="mt-2">
                        <span>Fax:</span>
                        <span class="text-muted ml-1 font-weight-bold">{{c.addresses[0]?.fax_number}}</span>
                      </div>
                      <!--<div class="mb-2">
                        <span>Email:</span>
                       <span class="text-muted ml-1 font-weight-bold">{{provider.email}}</span> </div>-->

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>


    </div>
  </div>

  <footer class="p-3">
    <div class="container p-0">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
          <button class="btn btn-primary w-100" [disabled]="selectedProvider == ''" type="button" (click)="confirmReferral()">Confirm</button>

        </div>
      </div>
    </div>
  </footer>

</ng-container>

<!-- show details-->

<ng-container style="margin-top:50px;" *ngIf="confirmScreen">
  <div class="wrapper">
    <div class="container flex-grow-1 overflow-auto mt-5">
      <div class=" pb-2 fw-bold">
        <h5 class="title fw-bold text-center mb-2 mt-2 ">Referral Physician Selection<span class="ml-1 text-dark"><i class="fas fa-info-circle " (click)="showReferralInfoPopup()"></i></span></h5>

      </div>
      <div class="specialist-list mt-3">
        <div class="row">
          <div class="col-lg-6">
            <div class="card mb-4">
              <div class="card-body p-0">
                <div style="font-size:16px;">
                  <span>I have scheduled the appointment with the following provider and would like </span><strong>Dr. {{ReferringDetails.name | titlecase}}</strong><span> to send referral to them.</span>

                </div>
                <div class="mt-4" style="font-size:16px;">
                  <strong>Dr. {{_addReferral.firsT_NAME | titlecase}} {{_addReferral.lasT_NAME |titlecase}} </strong><br>
                  <span>{{_addReferral.speciality |titlecase}}</span><br>
                  <span>Phone: {{_addReferral.phonE_NO}}</span><br>
                  <span *ngIf="_addReferral.fax">Fax: {{_addReferral.fax}} </span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>


      <div *ngIf="ShowFax">
        <div class="mb-2">
          <span style="font-size:19px">Fax number is missing. Please contact the referral provider directly to obtain it.</span>
        </div>

        <div class="form-group mb-2 border-bottom ">
          <label class="form-label padding-left fw-bold" style="font-size:20px">Fax Number<span class="text-danger">*</span></label>
          <input type="text" class="form-control border-0"
                 (input)="validatePhoneNo($event.target);validatePhone($any($event.target).value)" maxlength="14"
                 placeholder="Enter Fax Number" [(ngModel)]="providerfax" style="font-size:19px !important">
        </div>
        <span class="err" *ngIf="!isValidFax">Invalid Fax Number.</span>
        <span class="err" *ngIf="!isFax">
          Fax Number is required.
        </span>
        <div class="custom-control custom-checkbox mt-4" *ngIf="providerfax.length==0">
          <input class="custom-control-input" (change)="skipReferralFax($event)" type="checkbox" id="skipFax">
          <label class="custom-control-label" for="skipFax" style="font-size:19px">I have tried but couldn't get the fax number. </label>
        </div>
      </div>


    </div>
  </div>




  <footer class="p-3">
    <div class="container p-0">
      <div class="d-flex justify-content-between align-items-center">
        <button class="btn btn-outline-primary" type="button" (click)="onClickBack()">Back</button>
        <button class="btn btn-primary" type="button" (click)="addReferral()">Done</button>
      </div>
    </div>
  </footer>

</ng-container>



<ng-container style="margin-top:50px;" *ngIf="mainScreen">
  <div class="wrapper">
    <div class="container flex-grow-1 overflow-auto mt-5">

      <h5 class="mb-4 mt-2 p-1 text-center" *ngIf="referralStatus=='sent'" style="font-size:19px !important">
        <span >Your PCP has sent your referral to the specialist below.</span>
      </h5>

      <h5 class="mb-4 mt-2 text-center" *ngIf="referralStatus!='sent'" style="font-size:19.5px !important">
        <i class="fas fa-check-circle check_icon fa-lg mb-4"></i>
        <br>
        <span *ngIf="referralStatus=='new' || referralStatus=='noSuggestedProvider'"> <strong> Referral Physician Confirmed</strong></span>
        <span *ngIf="referralStatus=='confirm'"><strong> Referral Physician Already Confirmed</strong></span>
      </h5>

      <div class="row justify-content-center">
        <div class="col-md-6">

          <div class="card border">
            <div class="card-header bg-info font-weight-bold mb-0 p-3 text-white">
              <h5 class="fw-bold text-center mb-0" style="font-size:22px">Referral Physician Details</h5>
            </div>
            <div class="card-body p-3 text-center" *ngFor="let sRef of getSelectedReferralInfo">
              <h6 class="font-weight-bold mb-2" style="font-size:21px">Dr. {{sRef.referral_FirstName | titlecase }} {{sRef.referral_LastName | titlecase }}</h6>
              <div class="font-weight-bold mb-2 text-center">
                <span style="font-size:19px"> {{sRef.speciality | titlecase }}</span>
              </div>
              <div class="mb-2 text-center">
                <span style="font-size:17px"><strong>Phone:</strong><a href={{phoneLink}}>{{sRef.phonE_NO}}</a></span>
               
              </div>
              <div class=" text-center" *ngIf="sRef.faX_NO ">
                <span style="font-size:17px"><strong>Fax:</strong> {{sRef.faX_NO}}</span>
              </div>

            </div>

          </div>
        </div>

      </div>

      <div class="mt-4" *ngIf="referralStatus=='confirm' ||referralStatus=='new' || referralStatus=='noSuggestedProvider'">
        <span style="font-size:19px">
          You will receive an SMS with a link to print your referral once your provider sends it to the specialist.
        </span>
      </div>

    </div>
  </div>

  <footer class="p-3">
    <div class="container p-0">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
          <button *ngIf="referralStatus=='sent' || referralStatus=='noSuggestedProvider'" class="btn btn-primary w-100" type="button" (click)="generatePDF()">Print Referral Letter</button>
          <button *ngIf="referralStatus=='confirm' || referralStatus=='new'" class="btn btn-primary w-100" type="button" (click)="closetab()" >Close</button>
        </div>
      </div>
    </div>
  </footer>

</ng-container>



<ng-template #p1>
  <div class="p-2">

    <strong style="font-size:14px"> What I'm expected to do?</strong><br>

    <span style="font-size:14px" class="mt-2">
      <strong>Dr. {{ReferringDetails.name | titlecase }} </strong> has shared a list of specialists with you for
      your consultation regarding <strong>{{ReferralDetails.reason}}</strong>.<br>
      Take the following steps:
    </span><br>
    <span style="font-size: 14px" class="mt-2">
      <strong>1. Review the list:</strong> Browse the list Of providers
      shared by <strong>Dr. {{ReferringDetails.name | titlecase }} </strong> for your consultation
      regarding <strong>'{{ReferralDetails.reason}}'</strong>.
    </span><br>
    <span style="font-size: 14px" class="mt-3">
      <strong> 2. Schedule the appointment:</strong> Contact the
      provider of your choice to schedule an appointment.
    </span><br>
    <span style="font-size: 14px;margin-top:20px" class="mt-3">
      <strong> 3. Share your selection:</strong> Once your appointment is
      scheduled then share it with <strong>Dr. {{ReferringDetails.name | titlecase }}</strong>  by
      selecting that provider from the list.
    </span>

  </div>
</ng-template>


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="confirmReferralmodel">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-2"><strong>Are you sure you want to add this provider for your referral?</strong></h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal">
          {{'button.no'|translate}}
        </button>
        <button type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary " (click)="AddPatientReferral()">
          {{'button.yes'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse modal-full-height" id="referralinfo-modal">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"> Referral Physician Selection</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <strong style="font-size:16px"> What I'm expected to do?</strong><br>

        <p style="font-size:16px" class="mt-2">
          <strong>Dr. {{ReferringDetails.name | titlecase }} </strong> has shared a list of specialists with you for
          your consultation regarding <strong>{{ReferralDetails.reason}}</strong>.
        </p>
        <p style="font-size: 16px" class="mt-2">
          Take the following steps:<br><br>
          <strong>1. Review the list:</strong> Browse the list Of providers
          shared by <strong>Dr. {{ReferringDetails.name | titlecase }} </strong> for your consultation
          regarding <strong>'{{ReferralDetails.reason}}'</strong>.
        </p>
        <p style="font-size: 16px" class="mt-2">
          <strong> 2. Schedule the appointment:</strong> Contact the
          provider of your choice to schedule anappointment.
        </p>
        <p style="font-size: 16px" class="mt-2">
          <strong> 3. Share your selection:</strong> Once your appointment is
          scheduled then share it with <strong>Dr. {{ReferringDetails.name | titlecase }}</strong>  by
          selecting that provider from the list.
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary " data-dismiss="modal">{{'button.close'|translate}}</button>
      </div>
    </div>
  </div>
</div>



